var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.icons[_vm.currentIcon], _vm.size]})
}
var staticRenderFns = []

export { render, staticRenderFns }